import React, { lazy, Component } from 'react';
import { Zap } from 'lucide-react';
import { Product, WA_NUMBER } from '../data/products';
import { WhatsAppIcon } from './icons/WhatsAppIcon';
interface ProductCardProps {
  product: Product;
  onClick: () => void;
}
export function ProductCard({
  product,
  onClick
}: ProductCardProps) {
  const waMsg = encodeURIComponent(`Hola! Quiero el ${product.name} con 20% OFF — precio $${product.currentPrice}`);
  const waLink = `https://wa.me/${WA_NUMBER}?text=${waMsg}`;
  return <div onClick={onClick} className="bg-dark-600 border border-dark-400 rounded-lg overflow-hidden transition-all duration-300 cursor-pointer relative group hover:-translate-y-2 hover:shadow-[0_20px_50px_rgba(212,160,23,0.2)] hover:border-alphaGold" data-id="element-258">
      <div className="absolute top-[15px] left-[15px] bg-alphaGold text-white text-[0.75rem] font-black py-1 px-3 rounded-sm tracking-[1px] z-10" data-id="element-259">
        20% OFF
      </div>

      <div className="w-full aspect-square overflow-hidden bg-white flex items-center justify-center relative" data-id="element-260">
        <img src={product.image} alt={product.name} loading="lazy" className="w-full h-full object-contain p-4 transition-transform duration-400 group-hover:scale-105" onError={e => {
        e.currentTarget.src = product.fallbackImage;
      }} data-id="element-261" />
      </div>

      <div className="p-[25px]" data-id="element-262">
        <h3 className="text-[1.05rem] font-extrabold uppercase tracking-[1px] mb-2.5 text-white" data-id="element-263">
          {product.name}
        </h3>
        <p className="text-[0.88rem] text-[#999] leading-[1.65] mb-[15px]" data-id="element-264">
          {product.description.substring(0, 100)}...
        </p>

        <ul className="list-none mb-[18px] space-y-1.5" data-id="element-265">
          {product.benefits.slice(0, 3).map((benefit, idx) => <li key={idx} className="text-[0.82rem] text-[#bbb] pl-[18px] relative" data-id="element-266">
              <span className="absolute left-0 text-alphaGold font-black" data-id="element-267">
                ✓
              </span>
              {benefit}
            </li>)}
        </ul>

        <div className="flex items-center gap-3 mb-[18px] flex-wrap" data-id="element-268">
          <span className="text-[0.95rem] text-[#666] line-through" data-id="element-269">
            <span className="text-alphaGold font-bold text-[1rem] mr-0.5" data-id="element-270">
              $
            </span>
            {product.originalPrice.toLocaleString('es-UY')}
          </span>
          <span className="text-[1.8rem] font-black text-alphaGold" data-id="element-271">
            <span className="text-[1rem] align-top mt-1.5 inline-block mr-0.5" data-id="element-272">
              $
            </span>
            {product.currentPrice.toLocaleString('es-UY')}
          </span>
          <span className="bg-alphaGold/15 text-alphaGold text-[0.75rem] font-bold py-0.5 px-2.5 rounded-full border border-alphaGold/30" data-id="element-273">
            -20%
          </span>
        </div>

        <a href={waLink} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()} className="flex items-center justify-center gap-2 bg-whatsapp text-white text-[0.9rem] font-extrabold py-3.5 px-5 rounded uppercase tracking-[1px] transition-all duration-300 w-full hover:bg-whatsappDark hover:scale-[1.02]" data-id="element-274">
          <WhatsAppIcon data-id="element-275" />
          Pedir por WhatsApp
        </a>

        <div className="flex items-center gap-1.5 mt-3 text-[0.78rem] text-alphaGold font-semibold" data-id="element-276">
          <Zap className="w-3.5 h-3.5" data-id="element-277" /> Stock limitado — Oferta por tiempo
          limitado
        </div>
      </div>
    </div>;
}